"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const EditorText_1 = __importDefault(require("./EditorText"));
const style = {
    WebkitUserModify: 'read-write-plaintext-only',
    position: 'relative',
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
};
function EditorBlock(props) {
    const { block: _block } = props, renderProps = __rest(props, ["block"]);
    const RenderBlock = renderProps.renderBlock;
    let block = _block;
    let htmlAttrs = {};
    if (!props.readOnly) {
        htmlAttrs = {
            'data-block-key': block.blockKey,
            'data-fragment-start': 0,
            'data-fragment-end': block.value.length,
            style,
        };
    }
    const content = React.createElement(React.Fragment, null,
        React.createElement(EditorText_1.default, Object.assign({ key: "block-text", block: block }, renderProps)));
    if (RenderBlock != null) {
        return React.createElement(RenderBlock, Object.assign({ htmlAttrs: htmlAttrs, block: block }, renderProps), content);
    }
    return content;
}
exports.default = EditorBlock;
//# sourceMappingURL=EditorBlock.js.map